import { Route } from '@angular/router';
import { LineSelectionComponent } from '@features/activity-types/change-plan/line-selection/line-selection.component';
import { ManageServicesComponent } from '@features/activity-types/change-plan/manage-services/manage-services.component';
import { FinalizeOrderComponent } from '@features/shopping/finalize-order/finalize-order.component';
import { ReviewComponent } from '@features/shopping/review/review.component';

export const change_plan_routes: Route[] = [
  {
    path: 'line-selection',
    component: LineSelectionComponent,
    title: 'Select Line',
    data: { order_type_id: 11 }
  },
  {
    path: 'manage-service',
    component: ManageServicesComponent,
    title: 'Manage Services',
    data: { order_type_id: 11 }
  },
  {
    path: 'finalize-order',
    component: FinalizeOrderComponent,
    title: 'Finalize Your Order',
    data: { order_type_id: 11 }
  },
  {
    path: 'review/:id',
    component: ReviewComponent,
    title: 'Review Your Order',
    data: { order_type_id: 11 }
  },
  {
    path: '',
    redirectTo: 'line-selection',
    pathMatch: 'full'
  }
];
